import React from "react";
import { useMutation } from "react-query";
import { deactivateOfficeBMO } from "../../../../../actions/Utilities/OfficeBMO";
import { toast } from "../../../../../components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateOfficeBMO, officeBMOReFetching } from "../atoms/atoms";

export default function useDisableOfficeBMO() {
  const setActionEditState = useSetRecoilState(editStateOfficeBMO);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeBMOReFetching
  );
  
  const { mutate } = useMutation((ids: number[]) => deactivateOfficeBMO(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling Office BMO failed", res.Message, "error");
      } else {
      switch (true) {
        case res == "Success":
          toast.fire(
            "Success",
            "Office BMO Disabled Successfully",
            "success"
          );
          break;
        case res.includes("Notification insert Failed!"):
          toast.fire(
            "Success ",
            `Office BMO Disabled Successfully, BUT ${res}`,
            "warning"
          );
          break;
        case res.includes("Operation Failed!"):
            toast.fire(
                "Disabling Office BMO failed ",
                `Server Error: ${res}`,
                "error"
            );
            break;
        case res.includes("BMO not found"):
          toast.fire(
            "Disabling Office BMO failed ",
            `Error: ${res}`,
            "error"
          );
          break;
        default:
          toast.fire("Disabling Office BMO failed", res.Message, "error");
      }
    }
      // Redirect to View
      setActionEditState(false);
      
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling Office BMO failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}

